/* LIV3 mobile Add to Cart helpers: button feedback, GA4 events, sticky bar */
(function () {
  if (window.__l3m) return;
  window.__l3m = true;

  function track(name, form) {
    var params = { page_path: location.pathname, placement: name, item_id: (form.querySelector('[name="id"]') || {}).value };
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
    } catch (e) {}
  }

  // The theme's own handler (assets/script.js) does the AJAX add and opens the drawer.
  // This listener only adds tracking and button feedback.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('l3-atc-form')) return;
    track(form.getAttribute('data-l3-event') || 'atc_l3', form);
    var btn = form.querySelector('.l3-btn');
    if (!btn) return;
    btn.classList.add('is-added');
    btn.textContent = 'Added ✓';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = btn.getAttribute('data-label');
    }, 2500);
  }, true);

  function initSticky() {
    var bar = document.querySelector('.l3-sticky');
    if (!bar || !('IntersectionObserver' in window)) return;
    var start = document.querySelector('.l3m') || document.querySelector('.supplement_table');
    var footer = document.querySelector('footer, .footer, #shopify-section-footer');
    var inline = Array.prototype.slice.call(document.querySelectorAll('.l3-atc-inline'));
    var visible = new Set();
    var footerOn = false;

    function update() {
      var mobile = window.matchMedia('(max-width: 767.98px)').matches;
      var past = start ? start.getBoundingClientRect().top < 0 : window.scrollY > 600;
      var on = mobile && past && visible.size === 0 && !footerOn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.inert = !on;
      document.body.classList.toggle('l3-sticky-up', on);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === footer) footerOn = en.isIntersecting;
        else if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target);
      });
      update();
    });
    inline.forEach(function (el) { io.observe(el); });
    if (footer) io.observe(footer);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
